import React from "react";
import "./SoftwareSkill.scss";
import { FaJava, FaCss3Alt, FaHtml5, FaPython, FaGit, FaDocker, FaAws, FaReact, FaJenkins, FaGithub } from "react-icons/fa";
import { SiJavascript, SiSpringboot, SiHibernate, SiRedis, SiApachekafka, SiApachemaven, SiMysql, SiPostgresql, SiOracle, SiKubernetes, SiRedux, SiNumpy, SiPandas, SiPytorch, SiScikitlearn, SiFlask, SiJira, SiConfluence, SiSplunk, SiKibana } from "react-icons/si";

export default function SoftwareSkill() {
  const softwareSkills = [
    { skillName: "Java", icon: <FaJava /> },
    { skillName: "JavaScript", icon: <SiJavascript /> },
    { skillName: "Python", icon: <FaPython /> },
    { skillName: "CSS", icon: <FaCss3Alt /> },
    { skillName: "HTML", icon: <FaHtml5 /> },
    { skillName: "Spring Boot", icon: <SiSpringboot /> },
    { skillName: "Hibernate", icon: <SiHibernate /> },
    { skillName: "Redis", icon: <SiRedis /> },
    { skillName: "Kafka", icon: <SiApachekafka /> },
    { skillName: "Maven", icon: <SiApachemaven /> },
    { skillName: "Git", icon: <FaGit /> },
    { skillName: "MySQL", icon: <SiMysql /> },
    { skillName: "PostgreSQL", icon: <SiPostgresql /> },
    { skillName: "Oracle Database", icon: <SiOracle /> },
    { skillName: "Docker", icon: <FaDocker /> },
    { skillName: "Kubernetes", icon: <SiKubernetes /> },
    { skillName: "AWS", icon: <FaAws /> },
    { skillName: "Jenkins", icon: <FaJenkins /> },
    { skillName: "React", icon: <FaReact /> },
    { skillName: "Redux", icon: <SiRedux /> },
    { skillName: "Numpy", icon: <SiNumpy /> },
    { skillName: "Pandas", icon: <SiPandas /> },
    { skillName: "PyTorch", icon: <SiPytorch /> },
    { skillName: "Sklearn", icon: <SiScikitlearn /> },
    { skillName: "Flask", icon: <SiFlask /> },
    { skillName: "Jira", icon: <SiJira /> },
    { skillName: "GitHub", icon: <FaGithub /> },
    { skillName: "Confluence", icon: <SiConfluence /> },
    { skillName: "Splunk", icon: <SiSplunk /> },
    { skillName: "Kibana", icon: <SiKibana /> },
  ];

  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {softwareSkills.map((skill, i) => (
            <li key={i} className="software-skill-inline" name={skill.skillName}>
              <div className="icon">{skill.icon}</div>
              <p>{skill.skillName}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
